import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';
import { SubSection, useMasterData, useUserAccess } from '@ui-framework/index';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import JobsInProcess from './JobsInProcess';
import ClaimsServiceHistory from './ClaimsServiceHistory';

const ServiceHistory = forwardRef((props, ref) => {
  const userAccess = useUserAccess();
  const { getValues } = useFormContext();
  const serviceJob = getValues();
  const masterData = useMasterData();

  const allowProviderView = masterData?.serviceHistoryGroup.includes(
    serviceJob?.serviceJobStatus,
  );

  const jobAssignedToMe =
    userAccess?.isSA() ||
    userAccess?.isAdmin() ||
    (userAccess?.isSP() && allowProviderView);

  if (!jobAssignedToMe) {
    return (
      <Typography variant="body2">
        <FormattedMessage
          id="NO_HISTORY_AVAILABLE"
          defaultMessage="No history available"
        />
      </Typography>
    );
  }

  return (
    <Box ref={ref}>
      <SubSection>
        <Box>
          <ClaimsServiceHistory />
        </Box>
        <Box sx={{ marginTop: '10px' }}>
          <JobsInProcess />
        </Box>
      </SubSection>
    </Box>
  );
});

export default ServiceHistory;
